import React from 'react';
import { cn } from '@/lib/utils';

const InputComponent = React.forwardRef(({ className = '', type = 'text', ...props } = {}, ref) => {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-10 w-full rounded-input border bg-bg-surface px-3 py-2',
        'border-border-soft dark:border-border-soft',
        'text-sm text-text-primary placeholder:text-text-muted',
        'transition-[var(--transition-interactive)]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest-green dark:focus-visible:ring-accent-primary focus-visible:ring-offset-2 focus-visible:ring-offset-bg-page',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
});

InputComponent.displayName = 'Input';

export const Input = InputComponent;
